// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__235Sz","colMaxWidth":"Table_colMaxWidth__3YkuG"};